import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result'
import ListMutations from './list-mutations'
import MetaSearchAgency from '../entities/metaSearchAgency'

interface MetaSearchAgencyState extends ListState<MetaSearchAgency> {
    metaSearchAgency: MetaSearchAgency,
    editMetaSearchAgency: MetaSearchAgency,
}

class MetaSearchAgencyMutations extends ListMutations<MetaSearchAgency> {
}

class MetaSearchAgencyModule extends ListModule<MetaSearchAgencyState, any, MetaSearchAgency> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<MetaSearchAgency>(),
        loading: false,
        editMetaSearchAgency: new MetaSearchAgency(),
        selectMetaSearchAgency: new MetaSearchAgency(),
    }

    actions = {
        async getMetaSearchAgencies(context: ActionContext<MetaSearchAgencyState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Flight/GetMetaSearchAgencies', payload.data);
            console.log(response);
            context.state.loading = false;
            let page = response.data.result as PageResult<MetaSearchAgency>;

            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };

    mutations = {
        setCurrentPage(state: MetaSearchAgencyState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: MetaSearchAgencyState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const metaSearchAgencyModule = new MetaSearchAgencyModule();
export default metaSearchAgencyModule;
